const o = (t, n) => (l) => {
  const { formattedValue: r, floatValue: e } = l;
  return e == null ? r === "" : e <= (n || 1 / 0) && e >= (t || -1 / 0);
};
export {
  o as createIsAllowed
};
//# sourceMappingURL=createIsAllowed.mjs.map
